import Button from "components/Button";
import PlaidLinkComponent from "components/PlaidLink";
import { IPlaidAccount } from "models/HaulPay";
import { linkPlaidAccountAPI } from "services/api/userSetting";
import styles from "./style.module.scss";

interface IProps {
  onNext: (accounts: IPlaidAccount[]) => void;
}

export default function JoinBankAccounts({ onNext }: Readonly<IProps>) {
  const handlePlaidSuccess = async (publicToken: string, accounts: any[]) => {
    const requestBody = {
      public_token: publicToken,
      account_ids: accounts.map((account) => account.id)
    };

    const response = await linkPlaidAccountAPI(requestBody);
    onNext(response.data.accounts);
  };

  return (
    <form className={styles.accountContainer}>
      <h3 className={styles.header}>Account</h3>

      <div className={styles.body}>
        <PlaidLinkComponent
          label="Add Your Bank Info"
          btnClass="!h-14"
          className="mt-auto"
          onPlaidSuccess={handlePlaidSuccess}
          onPlaidFailed={() => onNext([])}
        />

        <p className="text-center text-error">
          Please enter your bank information for us to accelerate your application.
        </p>
      </div>

      <div className={styles.footer}>
        <Button
          size="lg"
          className="!w-full !px-32 !rounded-full desktop:!rounded-base desktop:!ml-auto desktop:!w-fit"
          onClick={() => onNext([])}>
          SKIP
        </Button>
      </div>
    </form>
  );
}
